import { render, staticRenderFns } from "./agendar-item.vue?vue&type=template&id=dafc42c2&"
import script from "./agendar-item.vue?vue&type=script&lang=js&"
export * from "./agendar-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports